import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "tv_dich_vu_tour_cho_duyet";

moduleApi.list = (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter
    };
    return ApiService(api);
};

moduleApi.clearCache = () => {
    ApiService.clearCache(new RegExp("/" + moduleName + "s([/?#].*)?$"));
};

moduleApi.findById = (id) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id }
    };
    return ApiService(api);
};

moduleApi.create = (dataForm) => {
    let api = {
        module: moduleName,
        type: "create",
        value: dataForm,
        message: {
            success: "Thêm mới thành công. Vui lòng bấm gửi để chuyển yêu cầu duyệt đến admin", //string | null | comment | hidden
            error: "Thêm mới thất bại!", //string | null | comment
        },
    };
    return ApiService(api);
};
moduleApi.createUpdate = (dataForm) => {
    let api = {
        module: moduleName,
        type: "create",
        value: dataForm,
        message: {
            success: "Thông tin cập nhật thành công. Vui lòng bấm gửi để chuyển yêu cầu duyệt đến admin", //string | null | comment | hidden
            error: "Thêm mới thất bại!", //string | null | comment
        },
    };
    return ApiService(api);
};

moduleApi.update = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm
    };
    return ApiService(api);
};

moduleApi.tourAgentupdate = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm,
        message: {
            success: "Thông tin đã được cập nhật. Vui lòng bấm gửi để chuyển yêu cầu cập nhật đến admin!", //string | null | comment
            error: "Cập nhật thông tin không thành công", //string | null | comment
        },
    };
    return ApiService(api);
};

moduleApi.updateSend = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm,
        message: {
            success: "Thông tin đã được gửi. Vui lòng chờ admin duyệt!", //string | null | comment
            error: "Cập nhật thông tin không thành công", //string | null | comment
        },
    };
    return ApiService(api);
};

moduleApi.delete = (id) => {
    let api = {
        module: moduleName,
        type: "delete",
        value: { id: id }
    };
    return ApiService(api);
};

moduleApi.approvedDichVuTour = (dataForm) => {
    let api = {
        module: moduleName,
        type: "approvedDichVuTour",
        value: dataForm,
        message: {
            success: "Duyệt tour thành công", //string | null | comment
            error: "Duyệt tour không thành công", //string | null | comment
        },
    };
    return ApiService(api);
};

export default moduleApi;